// API Configuration
const API_BASE_URL = "https://app.scottsoutter.com.au/api";
const API_TIMEOUT = 10000; // 10 seconds

export { API_BASE_URL, API_TIMEOUT };

